// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"195":"65be0e76","269":"15ea7853","682":"01270ec6","787":"154d47e1","922":"c307b509"}[chunkId] + ".chunk.js";
};